import BillableStatus, {
  billableStatus,
} from "@/modules/reports/billables/status";
import { Navigate, Outlet, createBrowserRouter } from "react-router-dom";
// import AnalyticsDashboard from "@/modules/reports/timesheet/analytics/dashboard";
// import { AnalyticsLayout } from "@/modules/reports/timesheet/analytics";
import AppShell4 from "@/layout";
import AverageFeedback from "@/modules/performance/average-feedback";
import { formatDateToDMY, ROUTE } from "@/lib/utils";
import EmailSignatures from "@/modules/apps/email-signature";
import Portfolio from "@/modules/apps/portfolio";
import Resume from "@/modules/apps/resume";
import Bookmarks from "@/modules/bookmarks";
import Clients from "@/modules/crm/clients";
import CreateClient from "@/modules/crm/clients/crud/create";
import UpdateClient from "@/modules/crm/clients/crud/update";
import Companies from "@/modules/crm/companies";
import CreateCompany from "@/modules/crm/companies/crud/create";
import UpdateCompany from "@/modules/crm/companies/crud/update";
import DirectusUILibrary from "@/modules/directus";
import Inbox from "@/modules/inbox";
import OrganizationEmployees from "@/modules/organization/employees";
import Performance from "@/modules/performance";
import PerformanceOverview from "@/modules/performance/overview";
import GivenFeedbacks from "@/modules/performance/given-feedbacks";
import UpdateFeedback from "@/modules/performance/given-feedbacks/update";
import PerformanceLayout from "@/modules/performance/layout";
import CreateQuadrimester from "@/modules/performance/quad/create";
import PerformanceReceivedFeedbacks from "@/modules/performance/feedbacks";
import PerformanceFeedback from "@/modules/performance/feedbacks/feedback";
import SelfEvaluationForm from "@/modules/performance/self-evaluation";
import TeamPerformance from "@/modules/performance/team-performance";
import EmployeeReviews from "@/modules/performance/team-performance/employee-reviews";
import BillablesDashboard from "@/modules/reports/billables/dashboard";
import ReportsLayout from "@/modules/reports/layout";
import { BestPerformers } from "@/modules/performance/best-performers";
import UnlockedRport from "@/modules/reports/timesheet/unlocked";
import RevenueDashboard from "@/modules/reports/revenue/dashboard";
import JobTypeReports from "@/modules/reports/revenue/type";
import DedicatedJobs from "@/modules/reports/revenue/type/dedicated";
import FixedJobs from "@/modules/reports/revenue/type/fixed";
import HourlyJobs from "@/modules/reports/revenue/type/hourly";
// import DepartmentAnalytics from "@/modules/reports/timesheet/analytics/department";
// import EmployeesTimesheetAnalytics from "@/modules/reports/timesheet/employees";
import EmployeeTimesheetOverview from "@/modules/reports/timesheet/employees/detail";
import TimesheetDashboard from "@/modules/timesheet/dashboard";
import TimesheetLog from "@/modules/timesheet/logs/log/create";
import TimesheetView from "@/modules/timesheet/logs/log/view";
import TimesheetLogsCalendar from "@/modules/timesheet/logs/views/calendar";
import TimesheetLogsDay from "@/modules/timesheet/logs/views/day";
import TimesheetLogsTable from "@/modules/timesheet/logs/views/table";
import TimesheetLogsWeek from "@/modules/timesheet/logs/views/week";
// Draft Timesheet imports
import DraftTimesheetLogsCalendar from "@/modules/timesheet/draft/views/calendar";
import DraftTimesheetLogsDay from "@/modules/timesheet/draft/views/day";
import DraftTimesheetLogsTable from "@/modules/timesheet/draft/views/table";
import DraftTimesheetLogsWeek from "@/modules/timesheet/draft/views/week";
import DraftTimesheetView from "@/modules/timesheet/draft/log/view";
// import ProjectTimesheet from "@/modules/timesheet/reviews";
import TimesheetReviewCalendar from "@/modules/timesheet/reviews/calendar";
import TimesheetReviewDayGrid from "@/modules/timesheet/reviews/days";
import ProjectsCoordinatingTimesheet from "@/modules/timesheet/reviews/projects-coordinating";
import JobsTimesheetFromProject from "@/modules/timesheet/reviews/projects-coordinating/detail";
import ProjectTimesheetDashboard from "@/modules/timesheet/reviews/review";
import TimesheetReview from "@/modules/timesheet/reviews/review/update";
import TimesheetReviewTableView from "@/modules/timesheet/reviews/table";
import TimesheetPlanning from "@/modules/timesheet/plan";
import Billables from "@/modules/work/billables";
import CreateBillable from "@/modules/work/billables/details/create";
import BillableDetails from "@/modules/work/billables/details/dashboard";
import UpdateBillable from "@/modules/work/billables/details/update";
// import Jobs from "@/modules/work/jobs";
// import Projects from "@/modules/work/projects";
import ProjectAnalyticsLayout from "@/modules/work/projects/analytics";
import JobsBurn from "@/modules/work/projects/analytics/burn";
import ProjectDepartmentWiseAnalytics from "@/modules/work/projects/analytics/departments";
import ProjectEmployeeWiseAnalytics from "@/modules/work/projects/analytics/employees";
import ProjectBillables from "@/modules/work/projects/billables/index";
import ProjectBookmarks from "@/modules/work/projects/bookmarks";
import ProjectDeliverables from "@/modules/work/projects/deliverables";
import CreateDeliverable from "@/modules/work/projects/deliverables/crud/create";
import UpdateDeliverable from "@/modules/work/projects/deliverables/crud/update";
import { ProjectIntegrations } from "@/modules/work/projects/integrations";
import { IntegrationDiscordChannel } from "@/modules/work/projects/integrations/discord";
import { IntegrationDriveFolder } from "@/modules/work/projects/integrations/drive";
import { IntegrationGithubRepo } from "@/modules/work/projects/integrations/github";
import ProjectJobs from "@/modules/work/projects/jobs";
import JobBillables from "@/modules/work/jobs/billables";
import JobBudget from "@/modules/work/jobs/analytics/budget";
import JobConfig from "@/modules/work/jobs/config/form";
import EmployeeListing from "@/modules/work/jobs/employees";
import EmployeeInputSheet from "@/modules/work/jobs/employees/input";
import JobEmployeeFormPage from "@/modules/work/jobs/employees/crud/form/page";
import JobsExtensions from "@/modules/work/jobs/extensions";
import CreateExtension from "@/modules/work/jobs/extensions/create";
import ExtensionDetail from "@/modules/work/jobs/extensions/detail";
import UpdateExtension from "@/modules/work/jobs/extensions/update";
import CreateJob from "@/modules/work/projects/jobs/create";
import JobDashboard from "@/modules/work/jobs/dashboard";
import UpdateJob from "@/modules/work/jobs/update";
import JobLayout from "@/modules/work/jobs/layout";
import JobMilestones from "@/modules/work/jobs/milestones";
import CreateMilestone from "@/modules/work/jobs/milestones/create";
import MilestoneDashboard from "@/modules/work/milestones/dashboard";
import UpdateMilestone from "@/modules/work/milestones/update";
import MilestoneLayout from "@/modules/work/milestones/layout";
import Milestones from "@/modules/work/milestones";
import JobbTimesheetDepartments from "@/modules/work/jobs/timesheet/departments";
import JobTimesheetEmployees from "@/modules/work/jobs/timesheet/employees";
import TimesheetJobCalendar from "@/modules/work/jobs/timesheet/history/calendar";
import JobTimesheetReviewDayGrid from "@/modules/work/jobs/timesheet/history/day";
import ProjectLayout from "@/modules/work/projects/layout";
import ProjectMilestones from "@/modules/work/projects/milestones";
import CreateProject from "@/modules/work/projects/project/crud/create";
import UpdateProject from "@/modules/work/projects/project/crud/update";
import ProjectDashboard from "@/modules/work/projects/project/dashboard";
import ProjectRevenue from "@/modules/work/projects/revenue";
import { MapRoutes } from "components/router/map-routes";
import { ForgotPassword } from "modules/auth/forgot-password";
import { ResetPassword } from "modules/auth/reset-password";
import Meme from "components/meme";
import Index from "@/modules/home";
import CostMaster from "@/modules/master-data/cost-master";
import CreateCostMaster from "@/modules/master-data/cost-master/crud/create";
import UpdateCostMaster from "@/modules/master-data/cost-master/crud/update";
import Countries from "@/modules/master-data/countries";
import CreateCountry from "@/modules/master-data/countries/crud/create";
import UpdateCountry from "@/modules/master-data/countries/crud/update";
import Currencies from "@/modules/master-data/currencies";
import CreateCurrency from "@/modules/master-data/currencies/crud/create";
import UpdateCurrency from "@/modules/master-data/currencies/crud/update";
import Departments from "@/modules/master-data/departments";
import CreateDepartment from "@/modules/master-data/departments/crud/create";
import UpdateDepartment from "@/modules/master-data/departments/crud/update";
import FunctionsList from "@/modules/master-data/functions";
import CreateFunction from "@/modules/master-data/functions/crud/create";
import UpdateFunction from "@/modules/master-data/functions/crud/update";
import Grades from "@/modules/master-data/grades";
import CreateGrade from "@/modules/master-data/grades/crud/create";
import UpdateGrade from "@/modules/master-data/grades/crud/update";
import Holidays from "@/modules/master-data/holidays";
import CreateHoliday from "@/modules/master-data/holidays/crud/create";
import UpdateHoliday from "@/modules/master-data/holidays/crud/update";
import JobTitles from "@/modules/master-data/job-titles";
import CreateJobTitle from "@/modules/master-data/job-titles/crud/create";
import UpdateJobTitle from "@/modules/master-data/job-titles/crud/update";
import Skills from "@/modules/master-data/skills";
import CreateSkill from "@/modules/master-data/skills/crud/create";
import UpdateSkill from "@/modules/master-data/skills/crud/update";
import CreateUser from "@/modules/organization/employees/crud/create";
import UpdateUser from "@/modules/organization/employees/crud/update";
import EmployeeProfileLayout from "@/modules/organization/employees/layout";
import OrganizationEntities from "@/modules/organization/entities";
import CreateEntity from "@/modules/organization/entities/crud/create";
import UpdateEntity from "@/modules/organization/entities/crud/update";
import MyProfileAbout from "@/modules/profile/about";
import MyProfileIntegrations from "@/modules/profile/integrations";
import IntegrationsRedirect from "@/modules/profile/integrations/redirect";
import MyProfileNavItems from "@/modules/profile/layout";
import MyProfileResponsibilities from "@/modules/profile/responsibilities";
import ProfileProjectCoordinator from "@/modules/profile/responsibilities/sections/project-coordinator";
import ProfileAccountManager from "@/modules/profile/responsibilities/sections/account-manager";
import ProfileSalesCoordinator from "@/modules/profile/responsibilities/sections/sales-coordinator";
import ProfileJobCoordinator from "@/modules/profile/responsibilities/sections/job-coordinator";
import ProfileMilestoneCoordinator from "@/modules/profile/responsibilities/sections/milestone-coordinator";
import ProfileDepartmentHead from "@/modules/profile/responsibilities/sections/department-head";
import ProfileDepartmentCoordinator from "@/modules/profile/responsibilities/sections/department-coordinator";
import ProfileReviewer from "@/modules/profile/responsibilities/sections/reviewer";
import ProfileTimesheetReviewer from "@/modules/profile/responsibilities/sections/timesheet";
import ProfileTeamLead from "@/modules/profile/responsibilities/sections/team-lead";
import UpdateQuadrimester from "@/modules/performance/quad/update";
import PullRequests from "@/modules/pull-requests";
import CreatePullRequest from "@/modules/pull-requests/create";
import UpdatePullRequest from "@/modules/pull-requests/update";
import BillablesExtensionsReports from "@/modules/reports/billables/extension";
import ContractBudget from "@/modules/work/contracts/budget/index";
import ContractLayout from "@/modules/work/contracts/layout";
import Contracts from "@/modules/work/contracts";
import ExtentionsJobsReports from "@/modules/reports/jobs/extentions";
import { OverrunJobsReports } from "@/modules/reports/jobs/overrun";
import JCOverviewReport from "@/modules/reports/jobs/overview";
import { UnderrunJobsReports } from "@/modules/reports/jobs/underrun";
// import EmployeeUtilizationOverview from "@/modules/reports/performance/department/employee";
// import EmployeeUtilizationDashboard from "@/modules/reports/performance/department/employee/dashboard";
// import DepartmentStatus from "@/modules/reports/performance/department/layout";
// import DepartmentOverview from "@/modules/reports/performance/department/overview";
import PendingSelfReviews from "@/modules/performance/pending-self-reviews";
import PendingReviews from "@/modules/performance/pendingreviews";
// import TimesheetHierarchy from "@/modules/reports/timesheet/hierarchy";
// import TimesheetTeam from "@/modules/reports/timesheet/team";
import SupportAllTickets from "@/modules/support/all-tickets";
import SupportNavItems from "@/modules/support/layout";
import SupportMyTickets from "@/modules/support/my-tickets";
import CreateTicket from "@/modules/support/my-tickets/crud/create";
import UpdateTicket from "@/modules/support/my-tickets/crud/update";
import TicketDetail from "@/modules/support/ticket";
import SupportHelp from "@/modules/support/help";
import BillableActivity from "@/modules/work/billables/activity";
import BillableExtensions from "@/modules/work/billables/details/extensions";
import CreateBillableExtension from "@/modules/work/billables/details/extensions/create";
import BillableLayout from "@/modules/work/billables/layout";
import { ProjectProvider } from "@/modules/work/projects/context";
import ProjectContracts from "@/modules/work/projects/contracts";
import CreateContract from "@/modules/work/projects/contracts/create";
import UpdateContract from "@/modules/work/contracts/update";
import SupportAssignedTickets from "@/modules/support/assigned";
// import ReviewerLoadView from "@/modules/performance/reviewer-load-view";
// import ReviewCoverage from "@/modules/performance/review-coverage";
import ReviewCoverageReviews from "@/modules/performance/review-coverage/reviews";
import ReviewerPerformanceReviews from "@/modules/performance/reviewer-load-view/reviews";
import Task from "@/modules/work/tasks/task";
// import { SignIn } from "@/modules/auth";
import { SignIn } from "modules/auth";
import Folders from "@/modules/organization/folders";
import FolderAssets from "@/modules/organization/folders/assets";
import ReviewerCoverage from "@/modules/performance/reviewer-load-view";
import RevieweeCoverage from "@/modules/performance/review-coverage";
import BillablesSlippageReports from "@/modules/reports/billables/slippage";
import Overdue from "@/modules/reports/billables/overdue";
import { formatName } from "utils/index";
import TimesheetDepartmentDashboard from "@/modules/reports/timesheet/department/dashboard";
import TimesheetDepartmentUtilization from "@/modules/reports/timesheet/department/utilization";
import TimesheetDepartmentOverview from "@/modules/reports/timesheet/department/overview";
import TimesheetDepartmentEmployees from "@/modules/reports/timesheet/department/employees";
import TimesheetDepartmentLayout from "@/modules/reports/timesheet/department/layout";
import TimesheetEmployeesUtilization from "@/modules/reports/timesheet/employees";
import TimesheetCalendarTeam from "@/modules/reports/timesheet/calendar/team";
import TimesheetCalendarHierarchy from "@/modules/reports/timesheet/calendar/hierarchy";
import TimesheetCalendarLayout from "@/modules/reports/timesheet/calendar/layout";
import DraftTimesheetLog from "@/modules/timesheet/draft/log/create";
import ContractJobs from "@/modules/work/contracts/jobs/index";
import UnreviewedHoursByJC from "@/modules/reports/timesheet/unreviewed-by-jc";
import Meetings from "@/modules/apps/meet";
import CreateMeeting from "@/modules/apps/meet/crud/create";
import UpdateMeeting from "@/modules/apps/meet/crud/update";
import PerformanceReport from "@/modules/reports/performance";
import OngoingLayout, {
  jobsOngoing,
} from "@/modules/reports/jobs/ongoing/layout";
import Surveys from "@/modules/work/jobs/survey";
import JobChallenges from "@/modules/work/jobs/challenges";
import CreateChallenge from "@/modules/work/jobs/challenges/crud/create";
import UpdateChallenge from "@/modules/work/jobs/challenges/crud/update";
import SurveyDetail from "@/modules/work/jobs/survey/detail";
import Tags from "@/modules/master-data/tags";
import CreateTag from "@/modules/master-data/tags/crud/create";
import UpdateTag from "@/modules/master-data/tags/crud/update";
import JobTimesheetTags from "@/modules/work/jobs/timesheet/tags";
import CreateSurvey from "@/modules/work/jobs/survey/crud/create";
import UpdateCsat from "@/modules/work/jobs/survey/crud/update";
import ClientDetail from "@/modules/crm/clients/dashboard";
import ClientLayout from "@/modules/crm/clients/layout";
import ClientSurveys from "@/modules/crm/clients/surveys";
import ClientTestimonials from "@/modules/crm/clients/testimonials";
import CreateTestimonial from "@/modules/crm/clients/testimonials/crud/create";
import UpdateTestimonial from "@/modules/crm/clients/testimonials/crud/update";
import Categories from "../modules/master-data/survey-category";
import CreateCategory from "@/modules/master-data/survey-category/crud/create";
import UpdateCategory from "@/modules/master-data/survey-category/crud/update";
import CategoryQuestions from "@/modules/master-data/category-question";
import CreateQuestion from "@/modules/master-data/category-question/crud/create";
import UpdateQuestion from "@/modules/master-data/category-question/crud/update";
import Teams from "@/modules/master-data/teams";
import CreateTeam from "@/modules/master-data/teams/crud/create";
import UpdateTeam from "@/modules/master-data/teams/crud/update";
import ProjectSurveys from "@/modules/work/projects/surveys";
import AddJobEmployee from "@/modules/work/jobs/employees/crud/create";
import BucketJobs from "@/modules/reports/revenue/type/bucket";
import RecurringJobs from "@/modules/reports/revenue/type/recurring";
import JobAnalytics from "@/modules/work/jobs/analytics/overview";
import Projects from "@/modules/work/projects";
import Jobs from "@/modules/work/jobs";
import Openings from "@/modules/apps/openings";
import CreateOpenings from "@/modules/apps/openings/crud/create";
import UpdateOpening from "@/modules/apps/openings/crud/update";
import OpeningDetails from "@/modules/apps/openings/components/detail";
import OpeningsLayout from "@/modules/apps/openings/layout";
import OpeningsInterviews from "@/modules/apps/openings/interviews";
import OpeningApplicants from "@/modules/apps/openings/applicants";
import CreateOpeningApplicant from "@/modules/apps/openings/applicants/crud/create";
import UpdateOpeningApplicant from "@/modules/apps/openings/applicants/crud/update";
import OpeningApplicantDetails from "@/modules/apps/openings/applicants/detail";
import CreateOpeningsInterview from "@/modules/apps/openings/interviews/crud/create";
import InterviewDetails from "@/modules/apps/openings/applicants/interviews/detail";
import UpdateOpeningsInterview from "@/modules/apps/openings/interviews/crud/update";
import InterviewApplicantDetails from "@/modules/apps/openings/interviews/detail";
import JobAllocation from "@/modules/work/jobs/allocation";
import CreateJobAllocation from "@/modules/work/jobs/allocation/crud/create";
import TimesheetMyTeamLayout from "@/modules/timesheet/my-team/layout";
import MyTeamTimesheetTable from "@/modules/timesheet/my-team/timesheet";
import MyTeamAcknowledgementTable from "@/modules/timesheet/my-team/acknowledgement";
import TasksLayout from "@/modules/work/tasks/layout";
import MeTasks from "@/modules/work/tasks/me";
import MyTeamTasks from "@/modules/work/tasks/my-team";
import AssignedByMeTasks from "@/modules/work/tasks/assigned-by-me";
import CreateTask from "@/modules/work/tasks/crud/create";
import JobTimesheetLogs from "@/modules/work/jobs/timesheet/logs";
import CreateKeka from "@/modules/organization/entities/dashboard/keka/create";
import EntityDashboard from "@/modules/organization/entities/dashboard";
import ContractDashboard from "@/modules/work/contracts/dashboard";
import GithubIntegrations from "@/modules/integrations/github";
import GithubRepoDashboard from "@/modules/integrations/github/repo";
import GithubBranchCommits from "@/modules/integrations/github/repo/branch";
import GithubPeople from "@/modules/integrations/github/people";
import DriveIntegrations from "@/modules/integrations/drive";
import DiscordIntegrations from "@/modules/integrations/discord";
import IntegrationLayout from "@/modules/integrations/layout";
import IntegrationsHub from "@/modules/integrations/hub";
import GithubIntegrationLayout from "@/modules/integrations/github/layout";
import GithubRepoLayout from "@/modules/integrations/github/repo/layout";
import DriveIntegrationLayout from "@/modules/integrations/drive/layout";
import DiscordIntegrationLayout from "@/modules/integrations/discord/layout";

const routeConfig = [
  {
    path: "/login",
    element: <SignIn />,
    public: true,
    handle: {
      crumb: () => "Login",
    },
  },
  {
    path: "/forgot-password",
    element: <ForgotPassword />,
    public: true,
    handle: {
      crumb: () => "Forgot Password",
    },
  },
  {
    path: "/reset-password",
    element: <ResetPassword />,
    public: true,
    handle: {
      crumb: () => "Forgot Password",
    },
  },
  {
    path: "/",
    element: <AppShell4 />,
    handle: {
      crumb: () => "Home",
    },
    children: [
      {
        index: true,
        element: <Navigate to="home" />,
      },
      {
        path: "directus-ui",
        element: <DirectusUILibrary />,
        handle: {
          crumb: () => "Directus UI",
        },
      },
      {
        path: "home",
        element: <Index />,
        handle: {
          crumb: () => "Home",
        },
      },
      {
        path: "inbox",
        element: <Outlet />,
        handle: {
          crumb: () => "Inbox",
        },
        children: [
          {
            index: true,
            element: <Inbox status="inbox" />,
          },
          {
            path: "cleared",
            element: <Inbox status="archived" />,
          },
        ],
      },

      {
        path: "bookmarks",
        element: <Outlet />,
        handle: {
          crumb: () => "Bookmarks",
        },
        children: [
          {
            index: true,
            element: <Bookmarks />,
          },
          // {
          //   path: "+",
          //   element: <Bookmarks /> ,
          // },
        ],
      },

      
          {
            path: "integrations",
            element: <IntegrationLayout />,
            handle: {
              crumb: () => "Integrations",
            },
            children: [
              {
                // Landing page: GitHub / Discord / Drive cards.
                index: true,
                element: <IntegrationsHub />,
              },
              {
                path: "github",
                // MapRoutes wraps every route's element, so a parent with no element
                // would render nothing; render the matched child (one of the two sidebars).
                element: <Outlet />,
                handle: {
                  crumb: () => "Github",
                },
                children: [
                  {
                    // GitHub sidebar (logo + Repositories).
                    element: <GithubIntegrationLayout />,
                    children: [
                      {
                        index: true,
                        element: <Navigate to="repositories" replace />,
                      },
                      {
                        path: "repositories",
                        element: <GithubIntegrations />,
                        handle: {
                          crumb: () => "Repositories",
                        },
                      },
                      {
                        path: "people",
                        element: <GithubPeople />,
                        handle: {
                          crumb: () => "People",
                        },
                      },
                    ],
                  },
                  {
                    // Repository sidebar (back, repo name, open on GitHub + Branches).
                    path: "repositories/:repo_id",
                    element: <GithubRepoLayout />,
                    handle: {
                      crumb: (data) => (data.isLoading.repository ? "Loading..." : data.repository || "Repository"),
                    },
                    children: [
                      {
                        index: true,
                        element: <Navigate to="branches" replace />,
                      },
                      {
                        path: "branches",
                        element: <GithubRepoDashboard />,
                        handle: {
                          crumb: () => "Branches",
                        },
                      },
                      {
                        path: "branches/:branch_name",
                        element: <GithubBranchCommits />,
                        handle: {
                          crumb: (data) => data.branch || "Commits",
                        },
                      },
                      {
                        path: "people",
                        element: <GithubPeople />,
                        handle: {
                          crumb: () => "People",
                        },
                      },
                    ],
                  },
                ],
              },
              {
                path: "drive",
                element: <DriveIntegrationLayout />,
                handle: {
                  crumb: () => "Drive",
                },
                children: [
                  {
                    index: true,
                    element: <DriveIntegrations />,
                  },
                  {
                    // Same folder access screen as the project page (reads :drive_id; :project_slug is the header text).
                    path: ":project_slug/:drive_id",
                    element: <IntegrationDriveFolder />,
                    handle: {
                      crumb: () => "Folder",
                    },
                  },
                ],
              },
              {
                path: "discord",
                element: <DiscordIntegrationLayout />,
                handle: {
                  crumb: () => "Discord",
                },
                children: [
                  {
                    index: true,
                    element: <DiscordIntegrations />,
                  },
                  {
                    // Same channel access screen as the project page (reads :chat_id; :project_slug is the header text).
                    path: ":project_slug/:chat_id",
                    element: <IntegrationDiscordChannel />,
                    handle: {
                      crumb: () => "Channel",
                    },
                  },
                ],
              },
            ],
          },

      {
        path: "profile",
        element: <MyProfileNavItems />,
        handle: {
          crumb: () => "Profile",
        },
        children: [
          {
            index: true,
            element: <Navigate to="about" />,
          },
          {
            path: "about",
            element: <MyProfileAbout />,
            handle: {
              crumb: () => "About",
            },
          },
          {
            path: "integrations",
            element: <Outlet />,
            handle: {
              crumb: "Integrations",
            },
            children: [
              {
                index: true,
                element: <MyProfileIntegrations />,
              },
              {
                path: "callback",
                element: <IntegrationsRedirect />,
              },
            ],
          },
          {
            path: "responsibilities",
            element: <MyProfileResponsibilities />,
            handle: {
              crumb: () => "Responsibilities",
            },
            children: [
              {
                index: true,
                element: <Navigate to="project-coordinator" />,
              },
              {
                path: "project-coordinator",
                element: <ProfileProjectCoordinator />,
                handle: { crumb: () => "Project Coordinator" },
              },
              {
                path: "account-manager",
                element: <ProfileAccountManager />,
                handle: { crumb: () => "Account Manager" },
              },
              {
                path: "sales-coordinator",
                element: <ProfileSalesCoordinator />,
                handle: { crumb: () => "Sales Coordinator" },
              },
              {
                path: "job-coordinator",
                element: <ProfileJobCoordinator />,
                handle: { crumb: () => "Job Coordinator" },
              },
              {
                path: "milestone-coordinator",
                element: <ProfileMilestoneCoordinator />,
                handle: { crumb: () => "Milestone Coordinator" },
              },
              {
                path: "department-head",
                element: <ProfileDepartmentHead />,
                handle: { crumb: () => "Department Head" },
              },
              {
                path: "department-coordinator",
                element: <ProfileDepartmentCoordinator />,
                handle: { crumb: () => "Department Coordinator" },
              },
              {
                path: "reviewer",
                element: <ProfileReviewer />,
                handle: { crumb: () => "Reviewer" },
              },
              {
                path: "timesheet",
                element: <ProfileTimesheetReviewer />,
                handle: { crumb: () => "Timesheet" },
              },
              {
                path: "team-lead",
                element: <ProfileTeamLead />,
                handle: { crumb: () => "Team Lead" },
              },
            ],
          },
        ],
      },
      {
        path: "tasks",
        element: <TasksLayout />,
        handle: {
          crumb: () => "Tasks",
        },
        children: [
          {
            index: true,
            element: <Navigate to="me" />,
          },
          {
            path: "+",
            element: <CreateTask />,
            handle: {
              crumb: () => "Create",
            },
          },
          {
            path: "me",
            element: <Outlet />,
            children: [
              { index: true, element: <MeTasks status="open" /> },
              { path: "completed", element: <MeTasks status="completed" /> },
              {
                path: ":taskId",
                element: <Task />,
                handle: {
                  crumb: (data) => {
                    if (data.isLoading.task) return "Loading...";
                    return data.task;
                  },
                },
              },
            ],
          },
          {
            path: "my-team",
            element: <Outlet />,
            children: [
              { index: true, element: <MyTeamTasks status="open" /> },
              {
                path: "completed",
                element: <MyTeamTasks status="completed" />,
              },
              {
                path: ":taskId",
                element: <Task />,
                handle: {
                  crumb: (data) => {
                    if (data.isLoading.task) return "Loading...";
                    return data.task;
                  },
                },
              },
            ],
          },
          {
            path: "assigned-by-me",
            element: <Outlet />,
            children: [
              { index: true, element: <AssignedByMeTasks status="open" /> },
              {
                path: "completed",
                element: <AssignedByMeTasks status="completed" />,
              },
              {
                path: ":taskId",
                element: <Task />,
                handle: {
                  crumb: (data) => {
                    if (data.isLoading.task) return "Loading...";
                    return data.task;
                  },
                },
              },
            ],
          },
        ],
      },
      {
        path: "work",
        element: <Outlet />,
        handle: {
          crumb: () => "Work",
        },
        children: [
          {
            index: true,
            element: <Navigate to="projects" />,
          },
          {
            path: "projects",
            element: <Outlet />,
            handle: {
              crumb: () => "Projects",
            },
            children: [
              {
                index: true,
                element: <Projects />,
              },
              {
                path: "+",
                element: <CreateProject />,
                handle: {
                  crumb: () => "Create",
                },
                requiredPermissions: {
                  collection: "projects",
                  action: "create",
                },
              },
              {
                path: ":project_slug",
                element: <Outlet />,
                handle: {
                  crumb: (data) => {
                    if (data.isLoading.project) return "Loading...";
                    return data.project;
                  },
                },
                children: [
                  {
                    index: true,
                    element: <ProjectDashboard />,
                  },
                  {
                    path: "edit",
                    handle: {
                      crumb: () => "Edit",
                    },
                    element: (
                      <ProjectLayout>
                        <UpdateProject />
                      </ProjectLayout>
                    ),
                    requiredPermissions: {
                      collection: "projects",
                      action: "update",
                    },
                  },
                  {
                    path: "billables",
                    element: <Outlet />,
                    handle: {
                      crumb: () => "Billables",
                    },
                    children: [
                      {
                        index: true,
                        element: (
                          <ProjectLayout>
                            {" "}
                            <ProjectBillables />
                          </ProjectLayout>
                        ),
                        requiredPermissions: { collection: "billables" },
                      },
                      // { path: "+", element: <ProjectMilestoneCreate /> },
                    ],
                  },
                  {
                    path: "jobs",
                    element: <Outlet />,
                    handle: {
                      crumb: () => "Jobs",
                    },
                    children: [
                      {
                        index: true,
                        element: (
                          <ProjectLayout>
                            {" "}
                            <ProjectJobs />
                          </ProjectLayout>
                        ),
                      },
                      {
                        path: ":type/+",
                        element: (
                          <ProjectLayout>
                            {" "}
                            <CreateJob />
                          </ProjectLayout>
                        ),
                        handle: {
                          crumb: ({ type }) => `Create ${type} Job`,
                        },
                        requiredPermissions: {
                          collection: "jobs",
                          action: "create",
                        },
                      },
                    ],
                  },
                  {
                    path: "integrations",
                    element: <Outlet />,
                    handle: {
                      crumb: () => "Integrations",
                    },
                    children: [
                      {
                        index: true,
                        element: (
                          <ProjectLayout>
                            <ProjectIntegrations />
                          </ProjectLayout>
                        ),
                      },
                      {
                        path: "repository-services",
                        element: (
                          <ProjectLayout>
                            <Outlet />
                          </ProjectLayout>
                        ),
                        children: [
                          {
                            path: ":project_service_id/:repo_id",
                            element: <IntegrationGithubRepo />,
                            handle: {
                              crumb: () => "Github",
                            },
                          },
                        ],
                      },
                      {
                        path: "chat-services",
                        element: (
                          <ProjectLayout>
                            <Outlet />
                          </ProjectLayout>
                        ),
                        children: [
                          {
                            path: ":project_service_id/:chat_id",
                            element: <IntegrationDiscordChannel />,
                            handle: {
                              crumb: () => "Discord",
                            },
                          },
                        ],
                      },
                      {
                        path: "drive-services",
                        element: (
                          <ProjectLayout>
                            <Outlet />
                          </ProjectLayout>
                        ),
                        children: [
                          {
                            path: ":project_service_id/:drive_id",
                            element: <IntegrationDriveFolder />,
                            handle: {
                              crumb: () => "Google Drive",
                            },
                          },
                        ],
                      },
                    ],
                  },
                  {
                    path: "milestones",
                    element: <Outlet />,
                    handle: {
                      crumb: () => "Milestones",
                    },
                    children: [
                      {
                        index: true,
                        element: (
                          <ProjectLayout>
                            {" "}
                            <ProjectMilestones />
                          </ProjectLayout>
                        ),
                      },
                      // { path: "+", element: <ProjectMilestoneCreate /> },
                    ],
                  },
                  {
                    path: "contracts",
                    element: (
                      <ProjectLayout>
                        <Outlet />
                      </ProjectLayout>
                    ),
                    handle: {
                      crumb: () => "Contracts",
                    },
                    requiredPermissions: { collection: "contracts" },
                    children: [
                      {
                        index: true,
                        element: <ProjectContracts />,
                      },
                      {
                        path: "+",
                        element: <CreateContract />,
                      },
                    ],
                  },
                  {
                    path: "bookmarks",
                    element: <Outlet />,
                    handle: {
                      crumb: () => "Bookmarks",
                    },
                    children: [
                      {
                        index: true,
                        element: (
                          <ProjectLayout>
                            <ProjectBookmarks />
                          </ProjectLayout>
                        ),
                      },
                      {
                        path: "+",
                        element: (
                          <ProjectLayout>
                            <ProjectBookmarks />
                          </ProjectLayout>
                        ),
                      },
                      {
                        path: ":linkId",
                        element: (
                          <ProjectLayout>
                            <ProjectBookmarks />
                          </ProjectLayout>
                        ),
                      },
                    ],
                  },
                  {
                    path: "deliverables",
                    element: (
                      <ProjectLayout>
                        <Outlet />
                      </ProjectLayout>
                    ),
                    handle: {
                      crumb: () => "Deliverables",
                    },
                    requiredPermissions: {
                      type: "collection",
                      collection: "deliverables",
                    },
                    children: [
                      {
                        index: true,
                        element: <ProjectDeliverables />,
                      },
                      {
                        path: "+",
                        element: <CreateDeliverable />,
                        handle: {
                          crumb: () => "Create Deliverable",
                        },
                        requiredPermissions: {
                          type: "collection",
                          collection: "deliverables",
                          action: "create",
                        },
                      },
                      {
                        path: ":deliverableId",
                        element: <UpdateDeliverable />,
                        handle: {
                          crumb: () => "Update Deliverable",
                        },
                        requiredPermissions: {
                          type: "collection",
                          collection: "deliverables",
                          action: "read",
                        },
                      },
                    ],
                  },
                  {
                    path: "revenue",
                    element: (
                      <ProjectLayout>
                        <ProjectRevenue />
                      </ProjectLayout>
                    ),
                  },
                  // {
                  //   path: "analytics",
                  //   element: (
                  //     <ProjectLayout>
                  //       <ProjectAnalyticsLayout />
                  //     </ProjectLayout>
                  //   ),
                  //   handle: { crumb: () => "Analytics" },
                  //   children: [
                  //     {
                  //       index: true,
                  //       element: <Navigate to="departments" />,
                  //     },
                  //     {
                  //       path: "departments",
                  //       element: <ProjectDepartmentWiseAnalytics />,
                  //       handle: { crumb: () => "Departments" },
                  //     },
                  //     {
                  //       path: "employees",
                  //       element: <ProjectEmployeeWiseAnalytics />,
                  //       handle: { crumb: () => "Employees" },
                  //     },
                  //   ],
                  // },
                  {
                    requiredPermissions: {
                      collection: "surveys",
                      action: "read",
                    },
                    path: "surveys",
                    element: (
                      <ProjectLayout>
                        <ProjectSurveys />
                      </ProjectLayout>
                    ),
                    handle: {
                      crumb: () => "Surveys",
                    },
                  },
                ],
              },
            ],
          },
          {
            path: "jobs",
            element: <Outlet />,
            handle: {
              crumb: () => "Jobs",
            },
            children: [
              {
                index: true,
                element: <Jobs />,
              },
              {
                path: ":jobId",
                element: <JobLayout />,
                handle: {
                  crumb: (data) => {
                    if (data.isLoading.job) return "Loading...";
                    return data.job;
                  },
                },
                children: [
                  {
                    index: true,
                    element: <JobDashboard />,
                  },
                  {
                    path: "edit",
                    element: <UpdateJob />,
                    crumb: "Edit Job",
                    requiredPermissions: {
                      collection: "jobs",
                      action: "update",
                    },
                  },
                  {
                    path: "challenges",
                    element: <Outlet />,
                    handle: {
                      crumb: () => "Challenges",
                    },
                    requiredPermissions: {
                      collection: "job_challenges",
                      action: "read",
                    },
                    children: [
                      {
                        index: true,
                        element: <JobChallenges />,
                      },
                      {
                        path: "+",
                        element: <CreateChallenge />,
                        handle: {
                          crumb: () => "Add",
                        },
                        requiredPermissions: {
                          collection: "job_challenges",
                          action: "create",
                        },
                      },
                      {
                        path: ":challengeId",
                        element: <UpdateChallenge />,
                        handle: {
                          crumb: () => "Edit",
                        },
                        requiredPermissions: {
                          collection: "job_challenges",
                          action: "update",
                        },
                      },
                    ],
                  },
                  {
                    path: "milestones",
                    element: <Outlet />,
                    handle: {
                      crumb: () => "Milestones",
                    },
                    children: [
                      {
                        index: true,
                        element: <JobMilestones />,
                      },
                      {
                        path: "+",
                        element: <CreateMilestone />,
                        handle: {
                          crumb: () => "Create Milestone",
                        },
                        requiredPermissions: {
                          collection: "milestones",
                          action: "create",
                        },
                      },
                    ],
                  },
                  {
                    path: "timesheet",
                    element: <Outlet />,
                    handle: {
                      crumb: () => "Timesheet",
                    },
                    children: [
                      {
                        index: true,
                        element: <Navigate to="employees" />,
                      },
                      // {
                      //   path: "history",
                      //   element: <Outlet />,
                      //   handle: {
                      //     crumb: () => "History",
                      //   },

                      //   children: [
                      //     {
                      //       index: true,
                      //       element: <TimesheetJobCalendar />,
                      //     },
                      //     {
                      //       path: "date",
                      //       element: <JobTimesheetReviewDayGrid />,
                      //       handle: {
                      //         crumb: ({ day }) => formatDateToDMY(day),
                      //       },
                      //     },
                      //     {
                      //       path: "calendar",
                      //       element: <TimesheetJobCalendar />,
                      //       handle: {
                      //         crumb: () => "Calendar",
                      //       },
                      //     },

                      //     {
                      //       path: "day/:day",
                      //       element: <JobTimesheetReviewDayGrid />,
                      //       handle: {
                      //         crumb: ({ day }) => formatDateToDMY(day),
                      //       },
                      //     },
                      //   ],
                      // },
                      {
                        path: "departments",
                        element: (
                          <ProjectProvider>
                            <JobbTimesheetDepartments />{" "}
                          </ProjectProvider>
                        ),
                        handle: {
                          crumb: () => "Department",
                        },
                      },
                      {
                        path: "employees",
                        element: (
                          <ProjectProvider>
                            {" "}
                            <JobTimesheetEmployees />
                          </ProjectProvider>
                        ),
                        handle: {
                          crumb: () => "Employees",
                        },
                      },
                      {
                        path: "logs",
                        element: (
                          <ProjectProvider>
                            {" "}
                            <JobTimesheetLogs />
                          </ProjectProvider>
                        ),
                      },
                      {
                        path: "tags",
                        element: (
                          <ProjectProvider>
                            {" "}
                            <JobTimesheetTags />
                          </ProjectProvider>
                        ),
                        handle: {
                          crumb: () => "Tags",
                        },
                      },
                      {
                        path: "logs",
                        element: (
                          <ProjectProvider>
                            {" "}
                            <JobTimesheetLogs />
                          </ProjectProvider>
                        ),
                        handle: {
                          crumb: () => "Logs",
                        },
                      },
                    ],
                  },
                  {
                    path: "allocation",
                    element: <Outlet />,
                    handle: {
                      crumb: () => "Allocation",
                    },
                    children: [
                      {
                        index: true,
                        element: <JobAllocation />,
                        requiredPermissions: {
                          collection: "allocated_hours",
                          action: "read",
                        },
                      },
                      {
                        path: "+",
                        element: <CreateJobAllocation />,
                        handle: {
                          crumb: "Add Allocation",
                        },
                        requiredPermissions: {
                          collection: "allocated_hours",
                          action: "create",
                        },
                      },
                    ],
                  },
                  {
                    path: "config",
                    element: <JobConfig />,
                    handle: {
                      crumb: () => "Config",
                    },
                    requiredPermissions: {
                      collection: "dedicated_job_config",
                    },
                  },

                  {
                    path: "billables",
                    element: <Outlet />,
                    handle: {
                      crumb: () => "Billables",
                    },
                    requiredPermissions: { collection: "billables" },
                    children: [
                      { index: true, element: <JobBillables /> },
                      { path: "+", element: <CreateBillable /> },
                      {
                        path: ":billableId",
                        element: <Outlet />,
                        handle: {
                          crumb: (data) => {
                            if (data.isLoading.billable) return "Loading...";
                            return data.billable;
                          },
                        },
                        children: [
                          { index: true, element: <BillableDetails /> },
                          { path: "edit", element: <UpdateBillable /> },
                          {
                            path: "extensions/+",
                            element: <CreateBillableExtension />,
                          },
                        ],
                      },
                    ],
                  },
                  {
                    path: "analytics",
                    element: <Outlet />,
                    handle: {
                      crumb: () => "Analytics",
                    },
                    children: [
                      {
                        index: true,
                        element: <Navigate to="budget" />,
                      },
                      // {
                      //   path: "overview",
                      //   element: <JobAnalytics />,
                      //   handle: {
                      //     crumb: () => "Overview",
                      //   },
                      // },
                      {
                        path: "budget",
                        element: <JobBudget />,
                        handle: {
                          crumb: () => "Budget",
                        },
                      },
                    ],
                  },
                  {
                    path: "employees",
                    element: <Outlet />,
                    handle: {
                      crumb: () => "Employees",
                    },
                    children: [
                      {
                        index: true,
                        element: <EmployeeListing />,
                      },
                      {
                        path: "+",
                        element: <AddJobEmployee />,
                        handle: {
                          crumb: () => "Add Employee",
                        },
                      },
                      {
                        path: ":employeeId/edit",
                        element: <JobEmployeeFormPage />,
                        handle: {
                          crumb: () => "Edit Employee",
                        },
                      },
                    ],
                  },

                  {
                    path: "extensions",
                    element: <Outlet />,
                    handle: {
                      crumb: () => "Extensions",
                    },
                    children: [
                      { index: true, element: <JobsExtensions /> },
                      { path: "+", element: <CreateExtension /> },
                      {
                        path: ":extensionId",
                        element: <Outlet />,
                        children: [
                          { index: true, element: <ExtensionDetail /> },
                          { path: "edit", element: <UpdateExtension /> },
                        ],
                      },
                    ],
                  },
                  {
                    path: "allocation",
                    element: <Outlet />,
                    handle: {
                      crumb: () => "Allocation",
                    },
                    children: [
                      {
                        index: true,
                        element: <JobAllocation />,
                        requiredPermissions: {
                          collection: "allocated_hours",
                          action: "read",
                        },
                      },
                      {
                        path: "+",
                        element: <CreateJobAllocation />,
                        handle: {
                          crumb: "Add Budget Allocation",
                        },
                        requiredPermissions: {
                          collection: "allocated_hours",
                          action: "create",
                        },
                      },
                    ],
                  },
                  {
                    requiredPermissions: {
                      collection: "surveys",
                      action: "read",
                    },
                    path: "surveys",
                    element: <Outlet />,
                    handle: {
                      crumb: () => "Surveys",
                    },
                    children: [
                      {
                        index: true,
                        element: <Surveys />,
                      },
                      {
                        path: "+",
                        element: <CreateSurvey />,
                        handle: {
                          crumb: () => "Add",
                        },
                      },
                      {
                        path: ":surveyId",
                        element: <Outlet />,
                        handle: {
                          crumb: (data) => {
                            if (data.isLoading.survey) return "Loading...";
                            return data.survey;
                          },
                        },
                        children: [
                          {
                            index: true,
                            element: <SurveyDetail />,
                          },
                          {
                            path: "edit",
                            element: <UpdateCsat />,
                            handle: {
                              crumb: () => "Edit",
                            },
                          },
                        ],
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            path: "billables",
            element: <Outlet />,
            handle: {
              crumb: () => "Billables",
            },
            requiredPermissions: { collection: "billables" },

            children: [
              {
                index: true,
                element: <Billables />,
              },
              {
                path: ":billableId",
                element: <BillableLayout />,
                handle: {
                  crumb: (data) => {
                    if (data.isLoading.billable) return "Loading...";
                    return data.billable;
                  },
                },
                children: [
                  {
                    index: true,
                    element: <BillableDetails />,
                  },
                  {
                    path: "edit",
                    element: <UpdateBillable />,
                  },
                  {
                    path: "extensions",
                    element: <Outlet />,
                    handle: {
                      crumb: () => "Extensions",
                    },
                    children: [
                      { index: true, element: <BillableExtensions /> },
                      { path: "+", element: <CreateBillableExtension /> },
                    ],
                  },
                  {
                    path: "activity",
                    element: <BillableActivity />,
                  },
                ],
              },
            ],
          },
          {
            path: "milestones",
            element: <Outlet />,
            handle: {
              crumb: () => "Milestones",
            },
            children: [
              {
                index: true,
                element: <Milestones />,
              },
              {
                path: ":milestoneId",
                element: <MilestoneLayout />,
                handle: {
                  crumb: (data) => {
                    if (data.isLoading.milestone) return "Loading...";
                    return data.milestone;
                  },
                },
                children: [
                  { index: true, element: <MilestoneDashboard /> },
                  {
                    path: "edit",
                    element: <UpdateMilestone />,
                    requiredPermissions: {
                      collection: "milestones",
                      action: "update",
                    },
                  },
                ],
              },
            ],
          },
          {
            path: "contracts",
            element: <Outlet />,
            handle: {
              crumb: () => "Contracts",
            },
            requiredPermissions: { collection: "contracts" },
            children: [
              {
                index: true,
                element: <Contracts />,
              },
              {
                path: ":contractId",
                element: <ContractLayout />,
                handle: {
                  crumb: (data) => {
                    if (data.isLoading.contract) return "Loading...";
                    return data.contract;
                  },
                },
                children: [
                  { index: true, element: <ContractDashboard /> },
                  { path: "edit", element: <UpdateContract /> },
                  { path: "budget", element: <ContractBudget /> },
                  { path: "jobs", element: <ContractJobs /> },
                ],
              },
            ],
          },
        ],
      },
      {
        path: "crm",
        element: <Outlet />,
        handle: {
          crumb: () => "CRM",
        },
        requiredPermissions: {
          type: "collection",
          collection: "clients",
        },
        children: [
          {
            index: true,
            element: <Navigate to="clients" />,
          },
          {
            path: "clients",
            element: <Outlet />,
            requiredPermissions: {
              type: "collection",
              collection: "clients",
            },
            handle: {
              crumb: () => "Clients",
            },
            children: [
              {
                index: true,
                element: <Clients />,
              },
              {
                path: "+",
                element: <CreateClient />,
                handle: {
                  crumb: () => "Create Client",
                },
                requiredPermissions: {
                  type: "collection",
                  collection: "clients",
                  action: "create",
                },
              },
              {
                path: ":clientId",
                element: <ClientLayout />,
                requiredPermissions: {
                  type: "collection",
                  collection: "clients",
                  action: "read",
                },
                children: [
                  {
                    index: true,
                    element: <ClientDetail />,
                  },
                  {
                    path: "surveys",
                    element: <ClientSurveys />,
                    handle: {
                      crumb: () => "Surveys",
                    },
                    requiredPermissions: {
                      type: "collection",
                      collection: "surveys",
                    },
                  },
                  {
                    path: "testimonials",
                    element: <Outlet />,
                    handle: {
                      crumb: () => "Testimonials",
                    },
                    requiredPermissions: {
                      type: "collection",
                      collection: "testimonials",
                    },
                    children: [
                      {
                        index: true,
                        element: <ClientTestimonials />,
                      },
                      {
                        path: "+",
                        element: <CreateTestimonial />,
                        handle: {
                          crumb: () => "Create Testimonial",
                        },
                        requiredPermissions: {
                          type: "collection",
                          collection: "testimonials",
                          action: "create",
                        },
                      },
                      {
                        path: ":testimonialId",
                        element: <UpdateTestimonial />,
                        handle: {
                          crumb: () => "Update Testimonial",
                        },
                        requiredPermissions: {
                          type: "collection",
                          collection: "testimonials",
                          action: "read",
                        },
                      },
                    ],
                  },
                  {
                    path: "edit",
                    element: <UpdateClient />,
                    handle: {
                      crumb: () => "Update Client",
                    },
                  },
                ],
              },
            ],
          },
          {
            path: "companies",
            element: <Outlet />,
            handle: {
              crumb: () => "Companies",
            },
            requiredPermissions: {
              type: "collection",
              collection: "companies",
            },
            children: [
              {
                index: true,
                element: <Companies />,
              },
              {
                path: "+",
                element: <CreateCompany />,
                handle: {
                  crumb: () => "Create Company",
                },
                requiredPermissions: {
                  type: "collection",
                  collection: "companies",
                  action: "create",
                },
              },
              {
                path: ":companyId",
                element: <UpdateCompany />,
                handle: {
                  crumb: () => "Update Company",
                },
                requiredPermissions: {
                  type: "collection",
                  collection: "companies",
                  action: "read",
                },
              },
            ],
          },
        ],
      },
      {
        path: "timesheet",
        element: <Outlet />,
        handle: {
          crumb: () => "Timesheet",
        },
        children: [
          {
            index: true,
            element: <TimesheetDashboard />,
            handle: {
              crumb: () => "Dashboard",
            },
          },
          {
            path: "logs",
            element: <Outlet />,
            handle: {
              crumb: () => "Logs",
            },
            children: [
              {
                index: true,
                element: <TimesheetLogsDay />,
                handle: {
                  crumb: "",
                },
              },
              {
                path: ":timesheetId",
                element: <TimesheetView />,
                handle: {
                  crumb: () => "View Log",
                },
              },
              {
                path: "week",
                element: <TimesheetLogsWeek />,
                handle: {
                  crumb: () => "Week",
                },
              },

              {
                path: "table",
                element: <TimesheetLogsTable />,
                handle: {
                  crumb: () => "Table",
                },
              },
              {
                path: "calendar",
                element: <TimesheetLogsCalendar />,
                handle: {
                  crumb: () => "Calendar",
                },
              },

              {
                path: "+",
                element: <TimesheetLog />,
                handle: {
                  crumb: () => "Add Log",
                },
              },
            ],
          },
          {
            path: "reviews",
            element: <Outlet />,
            handle: {
              crumb: () => "Review",
            },
            children: [
              {
                index: true,
                element: <Navigate to="week" />,
              },
              {
                path: "week",
                element: <ProjectTimesheetDashboard />,
                handle: {
                  crumb: () => "Week",
                },
              },
              {
                path: "table",
                element: <TimesheetReviewTableView />,
                handle: {
                  crumb: () => "Table",
                },
              },
              {
                path: "calendar",
                element: <TimesheetReviewCalendar />,
                handle: {
                  crumb: () => "Calendar",
                },
              },
              {
                path: "day",
                element: <TimesheetReviewDayGrid />,
                handle: {
                  crumb: () => "Day",
                },
              },
              {
                path: "day/:day",
                element: <TimesheetReviewDayGrid />,
                handle: {
                  crumb: ({ day }) => formatDateToDMY(day),
                },
              },

              {
                path: ":timesheetId",
                element: <TimesheetReview />,
                handle: {
                  crumb: () => "",
                },
              },
              {
                path: "projects",
                handle: {
                  crumb: () => "Projects",
                },
                element: <Outlet />,
                children: [
                  { index: true, element: <ProjectsCoordinatingTimesheet /> },
                  {
                    path: ":projectSlug",
                    element: <JobsTimesheetFromProject />,
                  },
                ],
              },
            ],
          },
          {
            path: "plan",
            element: <TimesheetPlanning />,

            handle: {
              crumb: () => "Plan",
            },
          },
          {
            path: "my-team",
            element: <TimesheetMyTeamLayout />,
            handle: {
              crumb: () => "My Team",
            },
            children: [
              {
                index: true,
                element: <Navigate to="timesheet" />,
              },
              {
                path: "timesheet",
                element: <MyTeamTimesheetTable />,
                handle: {
                  crumb: () => "Timesheet",
                },
              },
              {
                path: "acknowledge",
                element: <MyTeamAcknowledgementTable />,
                handle: {
                  crumb: () => "Acknowledge",
                },
              },
            ],
          },
          {
            path: "draft",
            element: <Outlet />,
            handle: {
              crumb: () => "Draft",
            },
            children: [
              {
                index: true,
                element: <DraftTimesheetLogsDay />,
                handle: {
                  crumb: () => "Day",
                },
              },
              {
                path: ":draftId",
                element: <DraftTimesheetView />,
                handle: {
                  crumb: () => "View Draft",
                },
              },
              {
                path: "week",
                element: <DraftTimesheetLogsWeek />,
                handle: {
                  crumb: () => "Week",
                },
              },
              {
                path: "table",
                element: <DraftTimesheetLogsTable />,
                handle: {
                  crumb: () => "Table",
                },
              },
              {
                path: "calendar",
                element: <DraftTimesheetLogsCalendar />,
                handle: {
                  crumb: () => "Calendar",
                },
              },
              {
                path: "+",
                element: <DraftTimesheetLog />,
                handle: {
                  crumb: () => "Add Draft Log",
                },
              },
            ],
          },
        ],
      },
      {
        path: "reports",
        element: <ReportsLayout />,
        redirectTo: "/",
        handle: {
          crumb: () => "Reports",
        },
        children: [
          {
            index: true,
            element: <Navigate to="jobs" />,
          },
          {
            path: "billables",
            element: <Outlet />,
            handle: {
              crumb: () => "Billables",
            },

            children: [
              {
                index: true,
                element: <Navigate to="overdue" />,
              },

              {
                path: "overdue",
                element: <Overdue />,
                handle: {
                  crumb: () => "Overdue",
                },
              },
              {
                path: "dashboard",
                element: <BillablesDashboard />,
                handle: {
                  crumb: () => "Dashboard",
                },
                requiredPermissions: {
                  collection: "billables",
                  action: "read",
                  field: "amount",
                  type: "key",
                },
              },
              {
                path: "extensions",
                element: <BillablesExtensionsReports />,
                handle: {
                  crumb: () => "Extensions",
                },
                requiredPermissions: {
                  collection: "billable_extensions",
                  type: "collection",
                },
              },
              {
                path: "slippage",
                element: <BillablesSlippageReports />,
                handle: {
                  crumb: () => "Slippage",
                },
                requiredPermissions: {
                  collection: "billables",
                  action: "read",
                  field: "amount",
                  type: "key",
                },
              },

              {
                path: "status",
                element: <BillableStatus />,
                handle: {
                  crumb: () => "Status",
                },
                requiredPermissions: {
                  collection: "billables",
                  action: "read",
                  field: "amount",
                  type: "key",
                },
                children: [
                  {
                    index: true,
                    element: <Navigate to="contracted" />,
                  },
                  ...billableStatus.map((status) => ({
                    path: status.value,
                    element: <status.element />,
                    handle: {
                      crumb: () => status.label,
                    },
                  })),
                ],
              },
              {
                path: "type",
                element: <JobTypeReports />,
                handle: {
                  crumb: () => "By Type",
                },
                requiredPermissions: {
                  collection: "billables",
                  type: "field",
                  action: "read",
                  key: "amount",
                },
                children: [
                  {
                    path: "",
                    element: <Navigate to="dedicated" replace />,
                  },
                  {
                    path: "dedicated",
                    element: <DedicatedJobs />,
                    handle: {
                      crumb: () => "Dedicated",
                    },
                  },
                  {
                    path: "hourly",
                    element: <HourlyJobs />,
                    handle: {
                      crumb: () => "Hourly",
                    },
                  },
                  {
                    path: "fixed",
                    element: <FixedJobs />,
                    handle: {
                      crumb: () => "Fixed",
                    },
                  },
                  {
                    path: "bucket",
                    element: <BucketJobs />,
                    handle: {
                      crumb: () => "Bucket",
                    },
                  },
                  {
                    path: "recurring",
                    element: <RecurringJobs />,
                    handle: {
                      crumb: () => "Recurring",
                    },
                  },
                ],
              },
            ],
          },
          {
            path: "performance",
            element: <PerformanceReport />,

            handle: {
              crumb: () => "Performance",
            },
          },
          {
            path: "jobs",
            element: <Outlet />,
            handle: {
              crumb: () => "Jobs",
            },
            children: [
              {
                index: true,
                element: <Navigate to="overview" />,
              },
              {
                path: "overview",
                element: <JCOverviewReport />,
                handle: {
                  crumb: "Overview",
                },
              },
              {
                path: "extensions",
                element: <ExtentionsJobsReports />,
                handle: {
                  crumb: () => "Extensions",
                },
              },
              {
                path: "overrun",
                element: <OverrunJobsReports />,
                handle: {
                  crumb: () => "Overrun Report",
                },
              },
              {
                path: "underrun",
                element: <UnderrunJobsReports />,
                handle: {
                  crumb: () => "Underrun Report",
                },
              },
              {
                path: "ongoing",
                element: <OngoingLayout />,
                handle: {
                  crumb: () => "Ongoing",
                },

                children: [
                  {
                    index: true,
                    element: <Navigate to="fixed" />,
                  },
                  ...jobsOngoing.map((status) => ({
                    path: status.value,
                    element: <status.element />,
                    handle: {
                      crumb: () => status.label,
                    },
                  })),
                ],
              },
            ],
          },
          {
            path: "revenue",
            element: <Outlet />,
            handle: {
              crumb: () => "Revenue",
            },
            requiredPermissions: {
              collection: "billables",
              action: "read",
              field: "amount",
              type: "key",
            },
            children: [
              {
                index: true,
                element: <Navigate to="dashboard" />,
              },
              {
                path: "dashboard",
                element: <RevenueDashboard />,
                handle: {
                  crumb: () => "Dashboard",
                },
              },
            ],
          },
          {
            path: "timesheet",
            element: <Outlet />,
            handle: {
              crumb: () => "Timesheet",
            },
            children: [
              {
                index: true,
                element: <Navigate to="employees" />,
              },
              {
                path: "department",
                element: <TimesheetDepartmentLayout />,
                handle: {
                  crumb: () => "Department",
                },
                children: [
                  {
                    index: true,
                    element: <Navigate to="dashboard" />,
                  },
                  {
                    path: "dashboard",
                    element: <TimesheetDepartmentDashboard />,

                    handle: {
                      crumb: () => "Dashboard",
                    },
                  },
                  {
                    path: "utilization",
                    element: <TimesheetDepartmentUtilization />,
                    handle: {
                      crumb: () => "Utilization",
                    },
                  },
                  {
                    path: "overview",
                    element: <TimesheetDepartmentOverview />,
                    handle: {
                      crumb: () => "Overview",
                    },
                  },
                  {
                    path: "employees",
                    element: <TimesheetDepartmentEmployees />,
                    handle: {
                      crumb: () => "Employees",
                    },
                  },
                ],
              },
              {
                path: "employees",
                element: <Outlet />,
                handle: {
                  crumb: () => "Employees",
                },
                children: [
                  {
                    index: true,
                    element: <TimesheetEmployeesUtilization />,
                  },
                  {
                    path: ":employeeId",
                    element: <EmployeeTimesheetOverview />,
                    handle: {
                      crumb: () => "Overview",
                    },
                  },
                ],
              },
              {
                path: "unlocked",
                element: <UnlockedRport />,
                handle: {
                  crumb: () => "Unlocked",
                },
              },
              {
                path: "unreviewed-by-jc",
                element: <UnreviewedHoursByJC />,
                handle: {
                  crumb: () => "Unreviewed Hours By JC",
                },
              },
              // {
              //   path: "hierarchy",
              //   element: <TimesheetCalendarHierarchy />,

              //   handle: {
              //     crumb: () => "Hierarchy",
              //   },
              // },
              // {
              //   path: "team",
              //   element: <TimesheetCalendarTeam />,

              //   handle: {
              //     crumb: () => "Team",
              //   },
              // },
            ],
          },
        ],
      },
      {
        path: "support",
        element: <SupportNavItems />,
        handle: {
          crumb: () => "Support",
        },
        children: [
          {
            index: true,
            element: <Navigate to="my-tickets" />,
          },
          {
            path: "help",
            element: <SupportHelp />,
          },
          {
            path: "+",
            element: <CreateTicket />,
          },
          {
            path: "my-tickets",
            element: <Outlet />,
            children: [
              {
                index: true,
                element: <SupportMyTickets />,
              },

              {
                path: ":ticketId",
                element: <Outlet />,
                children: [
                  {
                    index: true,
                    element: <TicketDetail />,
                  },
                  {
                    path: "edit",
                    element: <UpdateTicket />,
                  },
                ],
              },
            ],
          },
          {
            path: "all-tickets",
            element: <Outlet />,
            children: [
              {
                index: true,
                element: <SupportAllTickets />,
              },
              {
                path: ":ticketId",
                element: <Outlet />,
                children: [
                  {
                    index: true,
                    element: <TicketDetail />,
                  },
                  {
                    path: "edit",
                    element: <UpdateTicket />,
                  },
                ],
              },
            ],
          },
          {
            path: "assigned-tickets",
            element: <Outlet />,
            children: [
              {
                index: true,
                element: <SupportAssignedTickets />,
              },
              {
                path: ":ticketId",
                element: <Outlet />,
                children: [
                  {
                    index: true,
                    element: <TicketDetail />,
                  },
                  {
                    path: "edit",
                    element: <UpdateTicket />,
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        path: "master-data",
        element: <Outlet />,
        handle: {
          crumb: () => "Master Data",
        },
        children: [
          {
            index: true,
            element: <Navigate to="departments" />,
          },
          {
            path: "departments",
            element: <Outlet />,
            handle: {
              crumb: () => "Departments",
            },
            children: [
              {
                index: true,
                element: <Departments />,
              },
              {
                path: "+",
                element: <CreateDepartment />,
                handle: {
                  crumb: () => "Create Department",
                },
              },
              {
                path: ":departmentId",
                element: <UpdateDepartment />,
                handle: {
                  crumb: () => "Edit Department",
                },
              },
              // {
              //   path: ":departmentId",
              //   element: <Outlet />,
              //   children: [
              //     {
              //       index: true,
              //       element: <DepartmentsDashboard />,
              //       handle: {
              //         crumb: () => "Department",
              //       },
              //     },
              //     {
              //       path: "edit",
              //       element: <UpdateDepartment />,
              //       handle: {
              //         crumb: () => "Edit Department",
              //       },
              //     },
              //   ],
              // },
            ],
          },
          {
            path: "currencies",
            element: <Outlet />,
            handle: {
              crumb: () => "Currencies",
            },
            children: [
              {
                index: true,
                element: <Currencies />,
              },
              {
                path: "+",
                element: <CreateCurrency />,
                handle: {
                  crumb: () => "Create Currency",
                },
              },
              {
                path: ":currencyId",
                element: <UpdateCurrency />,
                handle: {
                  crumb: () => "Update Currency",
                },
              },
            ],
          },
          {
            path: "job-titles",
            element: <Outlet />,
            handle: {
              crumb: () => "Job Titles",
            },
            children: [
              {
                index: true,
                element: <JobTitles />,
              },
              {
                path: "+",
                element: <CreateJobTitle />,
                handle: {
                  crumb: () => "Create Job Title",
                },
              },
              {
                path: ":jobtitleId",
                element: <UpdateJobTitle />,
                handle: {
                  crumb: () => "Update Job Title",
                },
              },
            ],
          },
          {
            path: "grades",
            element: <Outlet />,
            handle: {
              crumb: () => "Grades",
            },
            children: [
              {
                index: true,
                element: <Grades />,
              },
              {
                path: "+",
                element: <CreateGrade />,
                handle: {
                  crumb: () => "Create Grade",
                },
              },
              {
                path: ":gradeId",
                element: <UpdateGrade />,
                handle: {
                  crumb: () => "Update Grade",
                },
              },
            ],
          },
          {
            path: "functions",
            element: <Outlet />,
            handle: {
              crumb: () => "Functions",
            },
            children: [
              {
                index: true,
                element: <FunctionsList />,
              },
              {
                path: "+",
                element: <CreateFunction />,
                handle: {
                  crumb: () => "Create Functions",
                },
              },
              {
                path: ":functionId",
                element: <UpdateFunction />,
                handle: {
                  crumb: () => "Update Functions",
                },
              },
            ],
          },
          {
            path: "skills",
            element: <Outlet />,
            handle: {
              crumb: () => "Skills",
            },
            children: [
              {
                index: true,
                element: <Skills />,
              },
              {
                path: "+",
                element: <CreateSkill />,
                handle: {
                  crumb: () => "Create Skill",
                },
              },
              {
                path: ":skillId",
                element: <UpdateSkill />,
                handle: {
                  crumb: () => "Update Skill",
                },
              },
            ],
          },
          {
            path: "countries",
            element: <Outlet />,
            handle: {
              crumb: () => "Countries",
            },
            children: [
              {
                index: true,
                element: <Countries />,
              },
              {
                path: "+",
                element: <CreateCountry />,
                handle: {
                  crumb: () => "Create Country",
                },
              },
              {
                path: ":countryId",
                element: <UpdateCountry />,
                handle: {
                  crumb: () => "Update Country",
                },
              },
            ],
          },
          {
            path: "categories",
            element: <Outlet />,
            handle: {
              crumb: () => "Categories",
            },
            children: [
              {
                index: true,
                element: <Categories />,
              },
              {
                path: "+",
                element: <CreateCategory />,
                handle: {
                  crumb: () => "Create Category",
                },
              },
              {
                path: ":categoryId",
                element: <UpdateCategory />,
                handle: {
                  crumb: () => "Update Category",
                },
              },
            ],
          },
          {
            path: "category-questions",
            element: <Outlet />,
            handle: {
              crumb: () => "Questions",
            },
            children: [
              {
                index: true,
                element: <CategoryQuestions />,
              },
              {
                path: "+",
                element: <CreateQuestion />,
                handle: {
                  crumb: () => "Create Question",
                },
              },
              {
                path: ":questionId",
                element: <UpdateQuestion />,
                handle: {
                  crumb: () => "Update Question",
                },
              },
            ],
          },
          {
            path: "teams",
            element: <Outlet />,
            handle: {
              crumb: () => "Teams",
            },
            children: [
              {
                index: true,
                element: <Teams />,
              },
              {
                path: "+",
                element: <CreateTeam />,
                handle: {
                  crumb: () => "Create Team",
                },
              },
              {
                path: ":teamId",
                element: <UpdateTeam />,
                handle: {
                  crumb: () => "Update Team",
                },
              },
            ],
          },
          {
            path: "holidays",
            element: <Outlet />,
            handle: {
              crumb: () => "Holidays",
            },
            children: [
              {
                index: true,
                element: <Holidays />,
              },
              {
                path: "+",
                element: <CreateHoliday />,
                handle: {
                  crumb: () => "Create Holiday",
                },
              },
              {
                path: ":holidayId",
                element: <UpdateHoliday />,
                handle: {
                  crumb: () => "Update Holiday",
                },
              },
            ],
          },
          {
            path: "cost-master",
            element: <Outlet />,
            handle: {
              crumb: () => "Cost Master",
            },
            children: [
              {
                index: true,
                element: <CostMaster />,
              },
              {
                path: "+",
                element: <CreateCostMaster />,
                handle: {
                  crumb: () => "Create Cost Master",
                },
              },
              {
                path: ":costmasterId",
                element: <UpdateCostMaster />,
                handle: {
                  crumb: () => "Update Cost Master",
                },
                requiredPermissions: {
                  collection: "cost_masters",
                  action: "update",
                },
              },
            ],
          },
          {
            path: "tags",
            element: <Outlet />,
            handle: {
              crumb: () => "Tags",
            },
            children: [
              {
                index: true,
                element: <Tags />,
              },
              {
                path: "+",
                element: <CreateTag />,
                handle: {
                  crumb: () => "Create",
                },
              },
              {
                path: ":tagId",
                element: <UpdateTag />,
                handle: {
                  crumb: () => "Update",
                },
                requiredPermissions: {
                  collection: "tags",
                  action: "update",
                },
              },
            ],
          },
        ],
      },
      {
        path: "organization",
        element: <Outlet />,
        handle: {
          crumb: () => "Organization",
        },
        children: [
          {
            index: true,
            element: <Navigate to="employees" />,
          },
          {
            path: "folders",
            element: <Outlet />,
            handle: {
              crumb: () => "Folders",
            },
            children: [
              { index: true, element: <Folders /> },
              {
                path: "*",
                element: <Folders />,
                handle: {
                  crumb: (data) => {
                    if (data.isLoading.folder) return "Loading...";
                    return data.folder ?? "Assets";
                  },
                },
              },
            ],
          },
          {
            path: "employees",
            element: <Outlet />,
            handle: {
              crumb: () => "Employees",
            },
            children: [
              { index: true, element: <OrganizationEmployees /> },
              {
                path: "+",
                element: <CreateUser />,
              },
              {
                path: ":employeeId",
                element: <Outlet />,
                handle: {
                  crumb: (data) => {
                    if (data.isLoading.employee) return "Loading...";
                    return data.employee;
                  },
                },
                children: [
                  { index: true, element: <Navigate to="about" /> },
                  { path: "edit", element: <UpdateUser /> },
                  {
                    element: <EmployeeProfileLayout />,
                    children: [
                      {
                        path: "about",
                        element: <MyProfileAbout />,
                      },
                      {
                        path: "responsibilities",
                        element: <MyProfileResponsibilities />,
                        handle: { crumb: () => "Responsibilities" },
                        children: [
                          {
                            index: true,
                            element: <Navigate to="project-coordinator" />,
                          },
                          {
                            path: "project-coordinator",
                            element: <ProfileProjectCoordinator />,
                            handle: { crumb: () => "Project Coordinator" },
                          },
                          {
                            path: "account-manager",
                            element: <ProfileAccountManager />,
                            handle: { crumb: () => "Account Manager" },
                          },
                          {
                            path: "sales-coordinator",
                            element: <ProfileSalesCoordinator />,
                            handle: { crumb: () => "Sales Coordinator" },
                          },
                          {
                            path: "job-coordinator",
                            element: <ProfileJobCoordinator />,
                            handle: { crumb: () => "Job Coordinator" },
                          },
                          {
                            path: "milestone-coordinator",
                            element: <ProfileMilestoneCoordinator />,
                            handle: { crumb: () => "Milestone Coordinator" },
                          },
                          {
                            path: "department-head",
                            element: <ProfileDepartmentHead />,
                            handle: { crumb: () => "Department Head" },
                          },
                          {
                            path: "department-coordinator",
                            element: <ProfileDepartmentCoordinator />,
                            handle: { crumb: () => "Department Coordinator" },
                          },
                          {
                            path: "reviewer",
                            element: <ProfileReviewer />,
                            handle: { crumb: () => "Reviewer" },
                          },
                          {
                            path: "timesheet",
                            element: <ProfileTimesheetReviewer />,
                            handle: { crumb: () => "Timesheet" },
                          },
                          {
                            path: "team-lead",
                            element: <ProfileTeamLead />,
                            handle: { crumb: () => "Team Lead" },
                          },
                        ],
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            path: "entities",
            element: <Outlet />,
            requiredPermissions: {
              collection: "legal_entities",
              type: "collection",
            },
            children: [
              {
                index: true,
                element: <OrganizationEntities />,
                handle: {
                  crumb: () => "Entities",
                },
              },
              {
                path: "+",
                element: <CreateEntity />,
              },
              {
                path: ":entityId",
                element: <Outlet />,
                handle: {
                  crumb: () => "Entity",
                },
                children: [
                  {
                    index: true,
                    element: <EntityDashboard />,
                  },
                  {
                    path: "edit",
                    element: <UpdateEntity />,
                  },
                  {
                    path: "keka",
                    element: <CreateKeka />,
                    handle: {
                      crumb: () => "Keka",
                    },
                  },
                ],
              },
            ],
          },
          // {
          //   path: "departments",
          //   element: <OrganizationDepartments />,
          //   handle: {
          //     crumb: () => "Departments",
          //   },
          // },
          // {
          //   path: "grades",
          //   element: <OrganizationGrades />,
          //   handle: {
          //     crumb: () => "Grades",
          //   },
          // },
        ],
      },
      {
        path: "performance",
        element: <Outlet />,
        handle: {
          crumb: () => "Performance",
        },
        children: [
          { index: true, element: <Navigate to="overview" replace /> },
          { path: "overview", element: <PerformanceOverview /> },
          {
            path: "review",
            element: <Outlet />,
            children: [
              { index: true, element: <Performance /> },
              {
                path: "+",
                element: <CreateQuadrimester />,
                handle: {
                  crumb: () => "Create",
                },
                requiredPermissions: {
                  collection: "performance_review_months",
                  action: "create",
                },
              },
              {
                path: ":quadId/edit",
                element: <UpdateQuadrimester />,
                handle: {
                  crumb: (data) => {
                    if (data.isLoading.quad) return "Loading...";
                    return data.quad;
                  },
                },
                requiredPermissions: {
                  collection: "performance_review_months",
                  action: "update",
                },
              },

              {
                path: ":quadId",
                element: <PerformanceLayout />,
                handle: {
                  crumb: (data) => {
                    if (data.isLoading.quad) return "Loading...";
                    return data.quad;
                  },
                },
                children: [
                  {
                    index: true,
                    element: <Navigate to="feedbacks" />,
                  },
                  {
                    path: "leaderboard",
                    element: <BestPerformers />,
                  },
                  {
                    path: "pending-reviews",
                    element: <PendingReviews />,
                    handle: { crumb: () => "Pending Reviews" },
                    requiredPermissions: {
                      collection: "performance_review_months",
                      action: "create",
                    },
                  },
                  {
                    path: "pending-self-reviews",
                    element: <PendingSelfReviews />,
                    handle: { crumb: () => "Pending Self Reviews" },
                    requiredPermissions: {
                      collection: "performance_review_months",
                      action: "create",
                    },
                  },
                  {
                    path: "reviewer-coverage",
                    element: <Outlet />,
                    handle: { crumb: () => "Reviewer Coverage" },
                    requiredPermissions: {
                      collection: "performance_review_months",
                      action: "create",
                    },
                    children: [
                      { index: true, element: <ReviewerCoverage /> },
                      {
                        path: ":employeeId",
                        element: <ReviewerPerformanceReviews />,
                        handle: {
                          crumb: (data) => {
                            if (data.isLoading.employee) return "Loading...";
                            return data.employee;
                          },
                        },
                      },
                    ],
                  },
                  {
                    path: "reviewee-coverage",
                    element: <Outlet />,
                    handle: { crumb: () => "Reviewee Coverage" },
                    requiredPermissions: {
                      collection: "performance_review_months",
                      action: "create",
                    },
                    children: [
                      { index: true, element: <RevieweeCoverage /> },
                      {
                        path: ":employeeId",
                        element: <ReviewCoverageReviews />,
                        handle: {
                          crumb: (data) => {
                            if (data.isLoading.employee) return "Loading...";
                            return data.employee;
                          },
                        },
                      },
                    ],
                  },

                  {
                    path: "self-evaluation",
                    element: (
                      <>
                        <SelfEvaluationForm />
                      </>
                    ),
                    handle: {
                      crumb: () => "Self Evaluation",
                    },
                  },
                  {
                    path: "feedbacks",
                    element: <Outlet />,
                    handle: {
                      crumb: () => "Feedbacks",
                    },
                    children: [
                      {
                        index: true,
                        element: (
                          <>
                            <PerformanceReceivedFeedbacks />
                          </>
                        ),
                      },
                      {
                        path: "average",
                        element: (
                          <>
                            <AverageFeedback />
                          </>
                        ),
                        handle: {
                          crumb: () => "Average",
                        },
                      },
                      {
                        path: ":reviewId",
                        element: <PerformanceFeedback showReviewBy={true} />,
                      },
                    ],
                  },
                  {
                    path: "given-feedbacks",
                    element: <Outlet />,
                    handle: {
                      crumb: () => "Given Feedbacks",
                    },
                    children: [
                      {
                        index: true,
                        element: (
                          <>
                            <GivenFeedbacks />
                          </>
                        ),
                      },
                      {
                        path: ":reviewId",
                        element: <Outlet />,
                        children: [
                          {
                            index: true,
                            element: (
                              <PerformanceFeedback
                                showReviewOf={true}
                                showEdit={true}
                              />
                            ),
                          },
                          {
                            path: "edit",
                            element: <UpdateFeedback />,
                          },
                        ],
                      },
                    ],
                  },
                  {
                    path: "team-performance",
                    element: <Outlet />,
                    handle: {
                      crumb: () => "Team Performance",
                    },
                    children: [
                      {
                        index: true,
                        element: (
                          <>
                            <TeamPerformance />
                          </>
                        ),
                      },
                      {
                        path: ":employeeId",

                        element: <Outlet />,
                        handle: {
                          crumb: (data) => {
                            if (data.isLoading.employee) return "Loading...";
                            return data.employee;
                          },
                        },
                        children: [
                          {
                            index: true,
                            element: (
                              <>
                                <EmployeeReviews />
                              </>
                            ),
                          },
                          {
                            path: ":reviewId",
                            handle: {
                              crumb: (data) => {
                                if (data.isLoading.review) return "Loading...";
                                console.log("breadcrumb data", data);

                                return `Review by ${formatName(
                                  data.review?.reviewer,
                                )}`;
                              },
                            },
                            element: (
                              <PerformanceFeedback
                                showReviewOf={true}
                                showReviewBy={true}
                              />
                            ),
                          },
                          {
                            path: "average",
                            element: <AverageFeedback showEmployee={true} />,
                          },
                        ],
                      },
                    ],
                  },
                ],
              },

              {
                path: "pending-reviews",
                element: <PendingReviews />,
                handle: { crumb: () => "Pending Reviews" },
              },
              {
                path: "pending-self-reviews",
                element: <PendingSelfReviews />,
                handle: { crumb: () => "Pending Self Reviews" },
              },
            ],
          },
        ],
      },
      {
        path: "apps",
        element: <Outlet />,
        handle: {
          crumb: () => "Apps",
        },
        children: [
          {
            index: true,
            element: <Navigate to="pull-requests" />,
          },
          {
            path: "meet",
            element: <Outlet />,
            handle: {
              crumb: () => "Meet",
            },
            children: [
              {
                index: true,
                element: <Meetings />,
              },
              {
                path: "+",
                element: <CreateMeeting />,
                handle: { crumb: () => "Create" },
              },
              {
                path: ":meetingId",
                element: <UpdateMeeting />,
                handle: {
                  crumb: () => "Edit",
                },
              },
            ],
          },
          {
            path: "email-signature",
            element: <EmailSignatures />,
            handle: {
              crumb: () => "Email Signature",
            },
          },
          {
            path: "openings",
            element: <Outlet />,
            handle: {
              crumb: () => "Openings",
            },
            children: [
              {
                index: true,
                element: <Openings />,
              },
              {
                path: "+",
                element: <CreateOpenings />,
                handle: { crumb: () => "Create" },
              },
              {
                path: ":openingId",
                element: (
                  <OpeningsLayout>
                    <Outlet />
                  </OpeningsLayout>
                ),
                children: [
                  {
                    index: true,
                    element: <OpeningDetails />,
                    handle: {
                      crumb: () => "Overview",
                    },
                  },
                  {
                    path: "edit",
                    element: <UpdateOpening />,
                    handle: { crumb: () => "Edit" },
                  },
                  {
                    path: "interviews",
                    element: <Outlet />,
                    handle: { crumb: () => "Interviews" },
                    children: [
                      {
                        index: true,
                        element: <OpeningsInterviews />,
                      },
                      {
                        path: "+",
                        element: <CreateOpeningsInterview />,
                        handle: { crumb: () => "Create" },
                      },
                      {
                        path: ":interviewId",
                        element: <Outlet />,
                        children: [
                          {
                            index: true,
                            element: <InterviewApplicantDetails />,
                            handle: { crumb: () => "Details" },
                          },
                          {
                            path: "edit",
                            element: <UpdateOpeningsInterview />,
                            handle: { crumb: () => "Edit" },
                          },
                        ],
                      },
                    ],
                  },
                  {
                    path: "applicants",
                    element: <Outlet />,
                    children: [
                      {
                        index: true,
                        element: <OpeningApplicants />,
                        handle: { crumb: () => "Applicants" },
                      },
                      {
                        path: "+",
                        element: <CreateOpeningApplicant />,
                        handle: { crumb: () => "Create" },
                      },
                      {
                        path: ":applicantId",
                        element: <Outlet />,
                        children: [
                          {
                            index: true,
                            element: <OpeningApplicantDetails />,
                            handle: { crumb: () => "Details" },
                          },
                          {
                            path: "edit",
                            element: <UpdateOpeningApplicant />,
                            handle: { crumb: () => "Edit" },
                          },
                          {
                            path: ":interviewId",
                            element: <InterviewDetails />,
                            handle: { crumb: () => "Detail" },
                          },
                        ],
                      },
                    ],
                    handle: { crumb: () => "Applicants" },
                  },
                ],
              },
            ],
          },
          {
            path: "portfolio",
            element: <Portfolio />,
            handle: {
              crumb: () => "Portfolio",
            },
          },
          {
            path: "resume-builder",
            element: <Resume />,
            handle: {
              crumb: () => "Resume-Builder",
            },
          },
          {
            path: "pull-requests",
            element: <Outlet />,
            handle: {
              crumb: () => "Pull Requests",
            },
            children: [
              {
                index: true,
                element: <PullRequests />,
              },
              {
                path: "+",
                element: <CreatePullRequest />,
                handle: {
                  crumb: () => "Create",
                },
                requiredPermissions: {
                  collection: "pull_requests",
                  action: "create",
                },
              },
              {
                path: ":pullRequestId/edit",
                element: <UpdatePullRequest />,
                handle: {
                  crumb: () => "Edit",
                },
                requiredPermissions: {
                  collection: "pull_requests",
                  action: "update",
                },
              },
            ],
          },
        ],
      },
    ],
  },
];

const routes = createBrowserRouter(MapRoutes(routeConfig));

export default routes;
